import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
if (!BACKEND_URL) {
  // Fail closed: a build without the backend URL would silently POST to "/undefined/api/…", which the SPA fallback answers with 200 HTML
  // (the login page then shows "code sent" although no request ever reached the backend - production regression 2026-09-23).
  throw new Error("REACT_APP_BACKEND_URL is not set in this build; the frontend cannot reach the API");
}
export const API_BASE = `${BACKEND_URL}/api`;

function getCookie(name) {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  if (method !== "get") {
    const csrfToken = getCookie("jigsaw_csrf");
    if (csrfToken) {
      config.headers["X-CSRF-Token"] = csrfToken;
    }
  }
  return config;
});

api.interceptors.response.use((response) => {
  // Fail closed: an API answer that is not JSON (e.g. the SPA fallback page returned with 200) is never a success.
  const type = String(response.headers?.["content-type"] || "");
  const binary = response.config?.responseType && response.config.responseType !== "json";
  if (!binary && response.status !== 204 && !type.includes("application/json")) {
    const err = new Error(`Unexpected non-JSON response from the API (${response.status}, ${type || "no content-type"})`);
    err.response = response;
    return Promise.reject(err);
  }
  return response;
});

export default api;
